import { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default function MapaPeru() {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const geoJsonLayer = useRef(null);
  const detalleRef = useRef(null);

  const [info, setInfo] = useState({
    titulo: "",
    imagen:
      "https://thumbs-us-east-1.myalbum.io/photo/1k0/4c04bda1-744c-435e-bc28-303dbc0845e6.jpg",
    descripcion:
      "Proyectos realizados por Teen Missions Perú, en algunas ciudades de nuestro pais. ",
    mostrarBoton: false,
    mostrarBoton1: false,
  });

  const departamentos = {
    UCAYALI: {
      titulo: "UCAYALI",
      imagen:
        "https://thumbs-us-east-1.myalbum.io/photo/1k0/2b9e4a0e-62a3-40fb-9e37-cd6c964a3dfe.jpg",
      descripcion:
        "Fueron dos equipos que realizaron sus proyectos en diferentes lugares, un equipo en Aguaytia donde evangelizaron en la ciudad e interactuaron con la etnia  Kakataibo y la comunidad shipiba de San Francisco, en el cual el equipo realizo la contrucción del piso de la iglesia de esa localidad. ",
      mostrarBoton: true,
      mostrarBoton1: true,
    },

    HUANUCO: {
      titulo: "HUANUCO",
      imagen:
        "https://thumbs-us-east-1.myalbum.io/photo/1k0/0effdca2-7595-473c-b1d7-5321c2d3711a.jpg",
      descripcion:
        "Durante dos años consecutivos hemos visitado la region de Huanuco-Ambo, realizando evangelismo a niños, adolescentes y adultos de esta ciudad con nuestros equipos, que fueron desafiados por el clima, pero llegaron a compartir el evangelio con muchas personas.",
      mostrarBoton: true,
    },

    JUNIN: {
      titulo: "JUNIN",
      imagen:
        "https://thumbs-us-east-1.myalbum.io/photo/1k0/78ea3666-39bd-408b-8939-8a9e3478424a.jpg",
      descripcion:
        "Nuestro equipo realizo evangelismo en la región de Huancayo, evangelizando en las calles y de persona a persona, apoyo al desarrollo de escuelas biblica de vacaciones en dos congregaciones.",
      mostrarBoton: true,
    },

    LIMA: {
      titulo: "LIMA",
      imagen:
        "https://thumbs-us-east-1.myalbum.io/photo/1k0/f18d1ab7-b686-4526-96fb-8c0c27c28541.jpg",
      descripcion:
        "Se desarrollo un trabajo en la parte sierra de lima, en la región Canta - Yangas, colaborando con la iglesia de la zona, se evangelizo a muchas personas al aire libre, visitando hogares y haciendo show para niños. ",
      mostrarBoton: true,
    },

    LORETO: {
      titulo: "LORETO",
      imagen:
        "https://thumbs-us-east-1.myalbum.io/photo/1k0/2a979024-c8ba-4f9b-82a2-445029127869.jpg",
      descripcion:
        "El equipo viajo a Contamana, fue una hermosa experiencia viajando en bote rapido por el rio Ucayali, durante este tiempo se realizo Evangelismo en las calles, al aire libre, de persona a persona e interactuaron con la etnia shipiba. ",
      mostrarBoton: true,
    },

    CUSCO: {
      titulo: "CUZCO",
      imagen:
        "https://thumbs-us-east-1.myalbum.io/photo/1k0/ad14a734-cd04-4654-b455-789cdcdd8093.jpg",
      descripcion:
        "Una experiencia inolvidable, el equipo de cusco ayudo en la construcción del perímetro del terreno de la congregación en esta ciudad y trabajaron en la  realización de escuelas bíblicas de vacaciones, evangelizando a niños y adolescentes.",
      mostrarBoton: true,
      mostrarBoton1: true,
    },
  };

  useEffect(() => {
    if (!mapRef.current) return;
    if (mapInstance.current) return;

    const map = L.map(mapRef.current, {
      zoomControl: true,
      attributionControl: false,
      minZoom: 3,
      maxZoom: 9,
    });

    mapInstance.current = map;

    // MAPA BASE
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
    }).addTo(map);

    // Vista inicial América
    map.setView([-12, -72], 4);

    const getNombre = (feature) => {
      return (
        feature.properties?.NOMBDEP ||
        feature.properties?.NAME_1 ||
        feature.properties?.name ||
        "SIN NOMBRE"
      ).toUpperCase();
    };

    const estilo = () => ({
      fillColor: "#22c55e",
      weight: 1,
      color: "#ffffff",
      fillOpacity: 0.75,
    });

    const hover = (e) => {
      const nombre = getNombre(e.target.feature);

      // Solo resaltar departamentos con proyectos
      if (departamentos[nombre]) {
        e.target.setStyle({
          fillColor: "#9b2a92",
          fillOpacity: 1,
          weight: 2,
          color: "#ffffff",
        });
      }
    };

    const reset = (e) => {
      e.target.setStyle({
        fillColor: "#22c55e",
        fillOpacity: 0.75,
        weight: 1,
        color: "#ffffff",
      });
    };

    const clickRegion = (e) => {
      const nombre = getNombre(e.target.feature);

      setInfo(
        departamentos[nombre] || {
          titulo: nombre,
          imagen:
            "https://thumbs-us-east-1.myalbum.io/photo/1k0/afc14afc-1329-4c3d-aa18-7ebc3aaa717a.jpg",
          descripcion:
            "Próximamente publicaremos información sobre los proyectos realizados en esta región.",
          mostrarBoton: false,
          mostrarBoton1: false,
        },
      );

      // Solo móviles
      if (window.innerWidth < 992) {
        setTimeout(() => {
          detalleRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 150);
      }
    };

    const onEachFeature = (feature, layer) => {
      const nombre = getNombre(feature);

      layer.bindTooltip(nombre, {
        sticky: true,
      });

      // Cursor tipo mano solo para departamentos con proyectos
      if (departamentos[nombre]) {
        layer.on("mouseover", () => {
          const el = layer.getElement?.();
          if (el) {
            el.style.cursor = "pointer";
          }
        });
      }

      layer.on({
        mouseover: hover,
        mouseout: reset,
        click: clickRegion,
      });
    };

    fetch(`${process.env.PUBLIC_URL}/peru_real.geojson`)
      .then((res) => res.json())
      .then((data) => {
        geoJsonLayer.current = L.geoJSON(data, {
          style: estilo,
          onEachFeature,
        }).addTo(map);

        setTimeout(() => {
          map.invalidateSize();
        }, 500);
      })
      .catch((err) => {
        console.error("Error cargando GeoJSON:", err);
      });

    return () => {
      if (mapInstance.current) {
        mapInstance.current.remove();
        mapInstance.current = null;
      }
    };
  }, []);

  return (
    <section
      className="container-fluid py-5 seccion-proyectos"
      style={{
        backgroundColor: "#101010",
      }}
    >
      <div className="container">
        <h1
            className="fw display-10 miTitulo"
          >
            Proyectos realizados en el Perú
          </h1>

        <div className="row g-4 align-items-stretch">
          {/* MAPA */}

          <div className="col-lg-7">
            <div
              className="shadow-lg"
              style={{
                borderRadius: "20px",
                overflow: "hidden",
                background: "#fff",
              }}
            >
              <div
                className="text-center"
                style={{
                  fontSize: "1.5rem",
                }}
              >
                <a>Selecciona un departamento del mapa</a>
              </div>
              <div
                ref={mapRef}
                style={{
                  width: "100%",
                  height: "700px",
                }}
              />
            </div>
          </div>

          {/* PANEL */}

          <div className="col-lg-5 panel-info-mapa" ref={detalleRef}>
            <div
              className="card border-0 shadow-lg h-100"
              style={{
                borderRadius: "20px",
                overflow: "hidden",
              }}
            >
              <img
                src={info.imagen}
                alt={info.titulo}
                style={{
                  height: "320px",
                  objectFit: "cover",
                }}
              />

              <div className="card-body p-4">
                <h3
                  className="fw-bold mb-3"
                  style={{
                    color: "#3d1042",
                  }}
                >
                  {info.titulo}
                </h3>

                <p
                  style={{
                    lineHeight: "1.9",
                    fontSize: "1rem",
                    color: "#0f0101",
                  }}
                >
                  <div className="text-center">
                    {info.mostrarBoton && (
                      <button
                        className="btn text-white rounded-pill px-4 mt-3"
                        style={{
                          background: "linear-gradient(135deg,#9b2a92,#3d1042)",
                          border: "none",
                        }}
                      >
                        Evangelismo
                      </button>
                    )}
                    <a> </a>
                    {info.mostrarBoton1 && (
                      <button
                        className="btn text-white rounded-pill px-4 mt-3"
                        style={{
                          background: "linear-gradient(135deg,#9b2a92,#3d1042)",
                          border: "none",
                        }}
                      >
                        Construcción
                      </button>
                    )}
                  </div>
                  <h3
                    className="fw mb-1"
                    style={{
                      color: "#0c040d",
                      fontSize: "1.3rem",
                      textAlign: "justify",
                    }}
                  >
                    {info.descripcion}
                  </h3>
                </p>
                {/* 
                <button
                  className="btn text-white rounded-pill px-4 mt-3"
                  style={{
                    background: "linear-gradient(135deg,#9b2a92,#3d1042)",
                    border: "none",
                  }}
                >
                  Ver Proyecto Completo
                </button>
*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
